import { render } from "./TweetForm.vue?vue&type=template&id=4f23a10c&scoped=true"
import script from "./TweetForm.vue?vue&type=script&lang=js"
export * from "./TweetForm.vue?vue&type=script&lang=js"

import "./TweetForm.vue?vue&type=style&index=0&id=4f23a10c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f23a10c"

export default script